
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learners/[learnerId]",
      function () {
        return require("private-next-pages/learners/[learnerId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learners/[learnerId]"])
      });
    }
  